/**
 * The following is adapted from https://github.com/scttcper/react-orgchart, which is licensed under MIT.
 * Original implementation by Scott Cooper.
 * Adapted by Ahmed Alcassab (@AhmedA1559) for use in the OrgTree component.
 */
import React from 'react';

import { init } from './chart/index.js';
import { Config, config as defaultConfig } from './chart/config.ts';

const defaultId = 'react-org-chart';

export interface TreeItem {
  [key: string]: TreeItem[] | any;
  id?: string | number;
  parentId?: string | number | null;
  children?: TreeItem[] | null;
  entity?: {
    [key: string]: any;
    avatar?: string;
    link?: string;
    name?: string;
    title?: string;
    office?: string;
    skills?: string[];
    salary?: number;
  };
}

type Props = Partial<Config> & {
  id?: string;
  disableCanvasMouseMove?: boolean;
  disableCanvasMouseWheelZoom?: boolean;
  tree: TreeItem[] | TreeItem;
};

export class OrgChart extends React.PureComponent<Props> {
  anchor = React.createRef();
  onDestroy!: () => void;

  componentDidMount() {
    const {
      id = defaultId,
      disableCanvasMouseMove = false,
      disableCanvasMouseWheelZoom = false,
      tree,
      ...options
    } = this.props;

    this.onDestroy = init({
      ...defaultConfig,
      id: `#${id}`,
      elem: this.anchor.current,
      data: tree,
      disableCanvasMouseMove,
      disableCanvasMouseWheelZoom,
      ...options,
    });
  }

  componentWillUnmount() {
    this.onDestroy();
  }

  render() {
    const { id = defaultId } = this.props;

    return React.createElement('div', {
      id,
      ref: this.anchor,
      style: { width: '100%', height: '100%' },
    });
  }
}
